export const bllSharedCellStyling = (e) => {
    const isData = e.rowType === 'data';
    const isHeader = e.rowType === 'header';
    const isFirstRow = isData && e.rowIndex === 0;

    if (isHeader) {
        e.cellElement.style.setProperty('color', 'black', 'important');
    }

    // Remove DevExtreme top border on the rowsview container (run once)
    if (isFirstRow) {
        const rowsView = e.component.element().querySelector('.dx-datagrid-rowsview');
        rowsView?.style.setProperty('border-top', 'none', 'important');
    }

    // Base padding for all data cells
    if (isData) {
        e.cellElement.style.setProperty('padding', '8px 10px', 'important');
    }

    // First column padding (header + data)
    if ((isData || isHeader) && e.columnIndex === 0) {
        e.cellElement.style.setProperty('padding', '8px 20px', 'important');
    }

    // Last column padding (header + data)
    const visibleColumns = e.component.getVisibleColumns();
    const lastColumnIndex = visibleColumns.length - 1;

    if ((isData || isHeader) && e.columnIndex === lastColumnIndex) {
        e.cellElement.style.setProperty('padding', '8px 20px', 'important');
    }

    // Remove faux top border on first data row
    if (isFirstRow) {
        e.cellElement.style.setProperty('border-top', 'none', 'important');
    }

    // Global cell styling
    e.cellElement.style.backgroundColor = 'white';
    e.cellElement.style.border = 'none';
};
